// Components
import { Body, BodyColor, BodyType } from '../../ui-elements';
import WorkInProgressImage from '../../utils/images/work_in_progress.svg'

interface WorkInProgressTemplateProps {
    size?: string;
}
export const WorkInProgressTemplate = ({ size }: WorkInProgressTemplateProps) => {
    return (
        <div className='w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-poi padding-top-bottom-5'>
            <div className='d-flex flex-row justify-content-center align-items-start' style={{ width: `${size === 'small' ? '80%' : '300px'}`, height: `${size === 'small' ? 'auto' : '200px'}` }}>
                <img src={WorkInProgressImage} className="w-100" alt="Work in progress" />
            </div>
            {/* <Heading
                title='Work in progress.'
                type={TypographyType.h5}
                colour={TypographyColor.primary}
                classname='padding-top-2'
            />
            <Body
                type={BodyType.p3}
                color={BodyColor.primary}
                classname='text-center margin-top-bottom-3 margin-left-right-0'
            >
                Our team is actively developing these features for the upcoming updates. Keep an eye out for more information.
            </Body> */}
            <Body
                type={BodyType.p3}
                color={BodyColor.primary}
                classname='text-center margin-top-bottom-3 margin-left-right-0'
            >
                Due to the limited number of points of interest in this category, the growth chart cannot be generated.
            </Body>

        </div>
    )
}

